


float PI = 3.141592653589793;
float RADIUS=0.5;
varying vec2 vUv;

// Arc Plane Fragment Shader (Maintaining X Position)
uniform float u_radius; // Radius of the arc
uniform float uArcHeight; // Height of the plane
uniform float uWidth; // Height of the plane
uniform float uProgress;
vec3 deformationCurve(vec3 position, vec2 uv) {
  float smoothProgress=smoothstep(0., 1., uProgress);
  position.z-=((sin(uv.y*PI)*0.2))*sin(smoothProgress*PI);

  return position;
}


void main() {
  
  vec3 deformedPosition=deformationCurve(position, uv);
 
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    
    // Pass UV for potential fragment shader use
    vUv = uv;
  vUv=uv;
}